import type { DisplayMode } from "./postComponentDisplay"
export type { DisplayMode }

export interface ConcertDisplayConfig {
  showLineup: DisplayMode
  showRelatedPosts: DisplayMode
  showComments: DisplayMode
}

export const DEFAULT_CONCERT_DISPLAY_CONFIG: ConcertDisplayConfig = {
  showLineup: "full",
  showRelatedPosts: "preview",
  showComments: "preview",
}
